import { useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import { api } from '@/api/client'
import type { Room } from '@/api/types'
import { RoomContent } from '@/components/RoomContent'
import { Select, Spinner } from '@/components/ui'
import { AdminPage, Card, ErrorNotice } from './AdminLayout'

export function WidgetsPage() {
  const query = useQuery({ queryKey: ['admin', 'widget-channels'], queryFn: ({ signal }) => api.get<{ channels: Room[] }>('/admin/widgets', undefined, signal) })
  const [chosen, setChosen] = useState('')
  const channels = [...(query.data?.channels ?? [])].sort((a, b) => (a.name ?? '').localeCompare(b.name ?? ''))
  const room = channels.find(channel => channel.id === chosen) ?? channels[0]
  return <AdminPage title="Widgets" lead="Connect a web page to a channel. Set its URL, optional bearer token and loading preferences.">
    <Card title="Channel" lead="Choose the local channel where the widget will appear.">
      {query.isPending ? <Spinner label="Loading channels" /> : query.error ? <ErrorNotice error={query.error} /> : channels.length ?
        <Select label="Channel" value={room?.id ?? ''} options={channels.map(channel => ({ value: channel.id, label: `#${channel.name ?? channel.slug}` }))} onChange={event => setChosen(event.target.value)} />
        : <p>No active local channels yet.</p>}
    </Card>
    {room ? <RoomContent key={room.id} room={room} view="widgets" /> : null}
  </AdminPage>
}
